
const OznakaBoje = function(DS) {

    return DS.defineResource({
        name: 'OznakaBoje',
        endpoint: '/oznakeBoja',
    });
};

OznakaBoje.$inject = ['DS'];


export {OznakaBoje};



// WEBPACK FOOTER //
// ./app/models/oznakaBoje.js